import { MerchProduct } from "@services/merch/types/api/merch-product";
import { TracPageLink } from "@services/tracpage/types/trac-page-link";
import TracPage from "@services/tracpage/types/trac-page";
import { SectionIdentifier } from "@services/tracpage/types/trac-page-section-id";
import { TourEvent } from "@common/types/traclink/tour-event";

export const getMainPageSortFn =
  <T extends MerchProduct | TracPageLink | TourEvent>(
    pageData: TracPage,
    sectionId: SectionIdentifier
  ) =>
  (a: T, b: T) => {
    const sectionConfig = pageData.itemsConfig?.[sectionId];
    const orderA = sectionConfig?.[a.id ?? ""]?.mainPageOrder ?? 0;
    const orderB = sectionConfig?.[b.id ?? ""]?.mainPageOrder ?? 0;

    return orderA - orderB;
  };

export const getSortMusicFn =
  (pageData: TracPage) => (a: TracPageLink, b: TracPageLink) => {
    const sectionConfig = pageData.itemsConfig?.[SectionIdentifier.MUSIC];

    const orderA = sectionConfig?.[a.id ?? ""]?.order;
    const orderB = sectionConfig?.[b.id ?? ""]?.order;

    if (orderA === undefined || orderB === undefined) {
      const innerOrderA = a.order;
      const innerOrderB = b.order;
      return innerOrderA - innerOrderB;
    }

    return orderA - orderB;
  };

export const getSortMerchFn =
  (pageData: TracPage) => (a: MerchProduct, b: MerchProduct) => {
    const sectionConfig = pageData.itemsConfig?.[SectionIdentifier.MERCH];

    const orderA = sectionConfig?.[a.id]?.order;
    const orderB = sectionConfig?.[b.id]?.order;

    if (orderA === undefined || orderB === undefined) {
      const dateA = new Date(a.createdAt).getTime();
      const dateB = new Date(b.createdAt).getTime();
      return dateB - dateA;
    }

    return orderA - orderB;
  };

export const getSortEventsFn =
  (pageData: TracPage) => (a: TourEvent, b: TourEvent) => {
    const sectionConfig = pageData.itemsConfig?.[SectionIdentifier.EVENTS];

    const orderA = sectionConfig?.[a.id]?.order;
    const orderB = sectionConfig?.[b.id]?.order;

    if (orderA === undefined || orderB === undefined) {
      const dateA = new Date(a.created_at).getTime();
      const dateB = new Date(b.created_at).getTime();
      return dateB - dateA;
    }

    return orderA - orderB;
  };
